module.exports = __webpack_public_path__ + "img/16.5.COD.ba6f781b.png";